import axios from "axios";
import Swal from "sweetalert2";
import * as Icons from "heroicons-react";
import { useEffect, useRef, useState } from "react";
import { Button, Form, Table } from "react-bootstrap";
import { Toaster } from "react-hot-toast";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import {
  resetTpn,
  selectNote,
  selectShipping,
  selectUser,
  tpnProductsAdd,
  tpnWarehouseForm,
  tpnWarehouseTo,
} from "../../features/tpnSlice";
import { useAddTpnMutation } from "../../services/tpnApi";
import { useWarehouseQuery } from "../../services/warehouseApi";
import TpnProductImporter from "../Common/CsvImporter/TpnProductImporter";
import TpnProductSearch from "../Common/CustomSelect/TpnProductSearch";
import WareHouseDWPurchase from "../Common/CustomSelect/WareHouseDWPurchase";
import Header from "../Common/Header/Header";
import LoadingModal from "../Common/Modal/LoadingModal";
import PackageModal from "../Common/Modal/PackageModal";
import SideBar from "../Common/SideBar/SideBar";
import useTpn from "../Hooks/useTpn";
import { signInUser } from "../Utility/Auth";
import { notify } from "../Utility/Notify";
import TpnProducts from "./TpnProducts";

const CreateTpn = () => {
  const auth = signInUser();
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const [wh, setWh] = useState("");
  let i = 1;
  const user = signInUser();
  const tpnData = useSelector((state) => state.tpnReducer);
  const BASE_URL =
    process.env.REACT_APP_API_URL || "http://localhost:5001/api/";
  const [loader, setLoader] = useState(false);
  const handleLoaderClose = () => setLoader(false);
  const [csvData, setCsvData] = useState([]);
  const [tpnProducts, setTpnProducts] = useState([]);
  const [addNewTpn] = useAddTpnMutation();
  const tpnProductsRef = useRef(null);
  const [modalVisible, setModalVisible] = useState(false);
  const closeModal = () => setModalVisible(false);
  //   console.log(user);
  // console.log(tpnData)
  // useEffect(() => {
  //     if (user) {
  //         dispatch(selectUser(user?.id));
  //     }
  // }, [user])
  const aamarId = auth?.aamarId;

  const [whName, setWhName] = useState("Warehouse");

  const { data: warehouseData, refetch: whRefetch } = useWarehouseQuery(
    user?.warehouse
  );

  useEffect(() => {
    if (user?.warehouse) {
      whRefetch();
    }
  }, [user?.warehouse, whRefetch]);

  useEffect(() => {
    if (user?.warehouse) {
      setWh(user?.warehouse);
      dispatch(tpnWarehouseForm(user?.warehouse));
    }
    dispatch(selectUser(user?.id));
  }, [user?.warehouse, user?.id]);

  useEffect(() => {
    if (warehouseData) {
      setWhName(warehouseData?.name);
      whRefetch();
    }
  }, [warehouseData, whRefetch]);
  // console.log("warehouse", warehouseData);

  const { totalItems } = useTpn();
  const { total_item, total, productList, total_shipping } = totalItems(
    tpnData?.products,
    tpnData?.shipping_cost
  );
  // console.log("total", total);

  const handleOnchangeWareHouseFrom = (e) => {
    // console.log(e);
    const selectedId = e?.option || e?.value || "";
    setWh(selectedId);
    dispatch(selectUser(user?.id));
    dispatch(tpnWarehouseForm(selectedId));
  };
  const handleOnchangeWareHouseTo = (e) => {
    // console.log(e);
    const selectedId = e?.option || e?.value || "";
    dispatch(tpnWarehouseTo(selectedId));
  };
  const addToList = async (data) => {
    // console.log(data);
    if (data) {
      // console.log("add to list:", data);
      await tpnProductsRef.current.blur();
      let listData = tpnData.products;

      let newProduct = {};
      // unique check
      const idExist = listData.find((pro) => pro.id === data._id);
      if (idExist) {
        notify("Product Already in List", "error");
        // console.log()
      } else {
        notify("Product is Added", "success");

        newProduct = {
          id: data?._id,
          name: data?.name,
          article_code: data?.article_code,
          qty: 1,
          order: listData?.length + 1,
          aamarId: auth?.aamarId,
          warehouse: auth?.warehouse,
          priceId: data?.priceList?.[0]?._id,
          tp: data?.priceList?.[0]?.tp !== undefined ? Number(data.priceList[0].tp) : 0,
          mrp: data?.priceList?.[0]?.mrp !== undefined ? Number(data.priceList[0].mrp) : 0,
          tax: 0,
          discount: 0,
        };
        listData = [...listData, newProduct];
      }

      // console.log("upcoming damage:", newProduct);
      // console.log("Updated damage:", listData);
      setTpnProducts(listData);
      dispatch(tpnProductsAdd(listData));
    } else {
      return false;
    }
  };

  const handleImportButton = async () => {
    if (!csvData || csvData.length === 0) {
      notify("There is no products to import", "error");
      return;
    }

    try {
      const importedProducts = [];
      const notFoundCodes = [];
      let i = 1;

      for (let idx = 0; idx < csvData.length; idx++) {
        const pro = csvData[idx];
        const code = pro?.article_code ? String(pro.article_code).trim() : "";
        if (!code) continue;

        try {
          const details = await axios(
            `${BASE_URL}product/pro-details/${encodeURIComponent(code)}`
          );
          const data = details?.data;

          if (details?.status === 200 && data && data?._id) {
            const activePrice =
              data?.priceList?.find((p) => p?.status === "active") ||
              data?.priceList?.[0] ||
              {};
            const tpVal =
              activePrice?.tp !== undefined && Number(activePrice.tp) >= 0
                ? Number(activePrice.tp)
                : 0;

            importedProducts.push({
              id: data._id,
              article_code: data.article_code || code,
              priceId: activePrice?._id || data._id,
              tp: tpVal,
              name: data.name,
              aamarId: auth?.aamarId,
              warehouse: auth?.warehouse,
              qty: Number(pro?.qty) > 0 ? Number(pro.qty) : 1,
              tax: 0,
              discount: 0,
              order: pro?.order ? Number(pro.order) : i++,
            });
          } else {
            notFoundCodes.push(code);
          }
        } catch (itemErr) {
          console.error(`Error importing product ${code}:`, itemErr);
          notFoundCodes.push(code);
        }
      }

      if (importedProducts.length > 0) {
        const currentProducts = tpnData?.products || [];
        const existingMap = new Map();
        currentProducts.forEach((p) => {
          existingMap.set(String(p.article_code || p.id), { ...p });
        });

        for (const item of importedProducts) {
          const key = String(item.article_code || item.id);
          if (existingMap.has(key)) {
            const existing = existingMap.get(key);
            existingMap.set(key, {
              ...existing,
              qty: Number(existing.qty || 0) + Number(item.qty || 1),
            });
          } else {
            existingMap.set(key, {
              ...item,
              order: existingMap.size + 1,
            });
          }
        }

        const mergedProducts = Array.from(existingMap.values());
        setTpnProducts(mergedProducts);
        dispatch(tpnProductsAdd(mergedProducts));
        notify(`${importedProducts.length} product(s) imported successfully!`, "success");
      }

      if (notFoundCodes.length > 0) {
        if (notFoundCodes.length <= 4) {
          notify(`Product(s) not found in store: ${notFoundCodes.join(", ")}`, "error");
        } else {
          notify(
            `${notFoundCodes.length} product(s) not found in store (e.g. ${notFoundCodes.slice(0, 3).join(", ")}...)`,
            "error"
          );
        }
      }
    } catch (err) {
      console.error("Import failed:", err);
      notify(err?.message || "Import failed", "error");
    }
  };
  const handleOnChangePrice = async (id, e) => {
    let newCart = [];
    console.log(e);
    try {
      let price = await axios.get(`${BASE_URL}price/${e.option}`);
      // console.log(price);
      let selected = tpnData.products.find((item) => item.id === id);
      let rest = tpnData.products.filter((item) => item.id !== id);
      if (price.data) {
        newCart = [
          ...rest,
          {
            ...selected,
            tp: price.data?.tp,
            mrp: price.data?.mrp,
            priceId: price.data?._id,
          },
        ];
        setTpnProducts(newCart);
      }
    } catch (err) {
      notify(err, "error");
    } finally {
      dispatch(tpnProductsAdd(newCart));
      // dispatch(selectProducts(newCart));
    }

    // localStorage.setItem("pos_cart", JSON.stringify(newCart));
    // console.log(e.option);
    // updateCart();
  };
  const handleCustomQty = (qty, id) => {
    // const qty = e.target.value();
    const selected = tpnData?.products?.find((p) => p.article_code === id);
    const rest = tpnData?.products?.filter((p) => p.article_code !== id);
    // console.log("selected", selected);
    // console.log("rest", rest);
    // console.log("id", id);
    let newProducts = [
      ...rest,
      {
        ...selected,
        qty: qty,
      },
    ];
    setTpnProducts(newProducts);
    dispatch(tpnProductsAdd(newProducts));
  };
  const removeFromCart = (id) => {
    const selected = tpnData?.products?.find((p) => p.id === id);
    const rest = tpnData?.products?.filter((p) => p.id !== id);

    // console.log(rest);

    dispatch(tpnProductsAdd(rest));
    setTpnProducts(rest);
  };

  // console.log("tpnLimited", auth);

  const handleTpnSubmit = async () => {
    // if (auth?.package?.tpnLimited === false) {
    //   setModalVisible(true);
    //   return;
    // } else {
    const newTpn = {
      ...tpnData,
      total: total,
      totalItem: total_item,
      aamarId,
      warehouse: tpnData?.warehouseFrom,
    };
    if (tpnData?.warehouseFrom === "") {
      notify("Please Select a warehouse From", "error");
    } else {
      if (tpnData?.warehouseTo === "") {
        notify("Please Select a warehouse To", "error");
      } else if (
        tpnData?.warehouseFrom &&
        tpnData?.warehouseTo &&
        tpnData?.warehouseFrom === tpnData?.warehouseTo
      ) {
        notify("Source and Destination Warehouse cannot be the same", "error");
      } else {
        if (tpnData?.products?.length > 0) {
          setLoader(true);
          console.log("tpnData", newTpn);
          await addNewTpn(newTpn)
            .then((res) => {
              console.log(res);
              if (res?.data) {
                notify("Transport Order Created Successfully", "success");
                dispatch(resetTpn());
                setLoader(false);
                navigate("/tpn");
              }
            })
            .catch((err) => {
              console.log(err);
              notify("Server Side Error", "error");
            });
        } else {
          notify("Please Select a Product", "error");
        }
      }
    }
    // }

    // console.log("tpnData", newTpn)
  };
  const emptyTpn = async () => {
    const result = await Swal.fire({
      title: "Are you sure?",
      text: "Refresh Cart! Start New TPN?",
      icon: "warning",
      showCancelButton: true,
      confirmButtonColor: "#3085d6",
      cancelButtonColor: "#d33",
      confirmButtonText: "Yes, Reset it!",
    });

    if (result.isConfirmed) {
      dispatch(tpnProductsAdd([]));
    } else {
      console.log("Refresh Operation Cancelled by User");
    }
  };
  return (
    <div>
      <div className="container-fluid">
        <LoadingModal
          title={"Please Wait"}
          onShow={loader}
          handleClose={handleLoaderClose}
        ></LoadingModal>
        <div className="row">
          <div className="col-md-2">
            <SideBar></SideBar>
          </div>
          <div className="col-md-10">
            <Header title="Product Out via TPN"></Header>
            <Form className="pt-3">
              <div className="row">
                <div className="col-6">
                  <Form.Group className="" controlId="warehouseFrom">
                    <Form.Label>Warehouse From</Form.Label>

                    {user?.type !== "admin" ? (
                      <>
                        <br />
                        {whName}
                      </>
                    ) : (
                      <WareHouseDWPurchase
                        id="warehouseFrom"
                        name="warehouseFrom"
                        handleOnChange={handleOnchangeWareHouseFrom}
                        wh={wh}
                      />
                    )}
                  </Form.Group>
                </div>
                <div className="col-6">
                  <Form.Group className="" controlId="warehouseTo">
                    <Form.Label>Warehouse To</Form.Label>
                    <WareHouseDWPurchase
                      id="warehouseTo"
                      name="warehouseTo"
                      handleOnChange={handleOnchangeWareHouseTo}
                      wh={tpnData?.warehouseTo}
                    />
                  </Form.Group>
                </div>
                <div className="col-md-6 my-3">
                  <Form.Label>Products</Form.Label>
                  <TpnProductSearch
                    className="searchProduct"
                    // getValue={getValue}
                    addToList={addToList}
                    tpnProductsRef={tpnProductsRef}
                  ></TpnProductSearch>
                </div>
                <div className="col-md-6 my-3 ">
                  <TpnProductImporter
                    setCsvData={setCsvData}
                    handleImportButton={handleImportButton}
                    title=""
                  />
                </div>
                <div className="col-12">
                  <div className="card">
                    <div className="card-header">Transported Products List</div>
                    <div className="card-body ">
                      <Table className="mt-3 ">
                        <thead>
                          <tr>
                            <th>#</th>
                            <th>Code</th>
                            <th>Name</th>
                            {/* <th>Tax</th> */}
                            <th>Quantity</th>
                            <th>TP</th>
                            {/* <th>Tax</th> */}
                            <th>Total</th>
                            <th>Actions</th>
                          </tr>
                        </thead>

                        <tbody>
                          <TpnProducts
                            tpnProducts={tpnData?.products}
                            i={i}
                            // removeQuantities={removeQuantities}
                            // addQuantities={addQuantities}
                            handleOnChangePrice={handleOnChangePrice}
                            handleCustomQty={handleCustomQty}
                            removeFromCart={removeFromCart}
                          ></TpnProducts>
                        </tbody>
                      </Table>
                    </div>
                  </div>
                </div>
                <div className="col-md-6 my-2">
                  <Form.Group className="" controlId="formBasicEmail">
                    <Form.Label>Shipping Cost</Form.Label>
                    <Form.Control
                      onChange={(e) => dispatch(selectShipping(e.target.value))}
                      type="number"
                      className="shipping"
                      placeholder="Shipping Cost"
                    />
                  </Form.Group>
                </div>
                <div className="col-md-6 my-2">
                  <Form.Group className="" controlId="formBasicEmail">
                    <Form.Label>Note</Form.Label>
                    <textarea
                      type="text"
                      className="form-control"
                      placeholder="Note"
                      onChange={(e) => dispatch(selectNote(e.target.value))}
                    />
                  </Form.Group>
                </div>
              </div>
              <Table className="bordered striped ">
                <thead>
                  <tr>
                    <th>Total Items: {total_item.toFixed(2)}</th>
                    <th>Product Cost:{total.toFixed(2)} </th>
                    <th>Shipping Cost:{tpnData?.shipping_cost} </th>
                    <th>Total Cost:{total_shipping.toFixed(2)} </th>
                  </tr>
                </thead>
              </Table>
              <Button
                variant="dark"
                onClick={handleTpnSubmit}
                className="float-end my-2"
                type="button"
              >
                <Icons.SaveOutline size={20} /> Submit
              </Button>
              <Button
                variant="dark"
                className="float-end my-2 mx-2"
                type="button"
                onClick={emptyTpn}
              >
                Reset Cart
              </Button>
            </Form>
          </div>
        </div>
      </div>
      <Toaster position="bottom-right" />
      {/* Package Info Modal */}
      <PackageModal show={modalVisible} handleClose={closeModal} />{" "}
    </div>
  );
};

export default CreateTpn;
